import api from '@services/api';
import { Cluster } from '../models/cluster';
import { CommonBasicRequest } from '../models/common';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all cluster related CRUD calls
 */
export const clusterApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    searchCluster: builder.query<PaginationResponse<Cluster>, CommonBasicRequest>({
      query: (params: CommonBasicRequest) => ({
        url: encodeURI(
          `/approvers/cluster/search?searchTerm=${params.searchTerm}&bringAll=${params.bringAll}&page=${params.page}&size=${params.size}&sortKey=${params.sortKey}&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Cluster'],
    }),
  }),
});

export const { useSearchClusterQuery } = clusterApi;
